import { useQuery } from "react-query";
import { getAcademicPeriods } from "../services/school/academicPeriod/getAcademicPeriods";
import { PagedRequestType } from "../types/PagedResults";

export const useGetAcademicPeriodQuery = (data: PagedRequestType) =>
  useQuery(
    ["academicPeriod-pagination", JSON.stringify(data)],
    () => getAcademicPeriods(data)
  );